var render, staticRenderFns
import script from "./mb.vue?vue&type=script&lang=js&"
export * from "./mb.vue?vue&type=script&lang=js&"
import style0 from "./mb.vue?vue&type=style&index=0&id=c36931fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36931fc",
  null
  
)

export default component.exports